import { useContext } from "react";
import { SWRResponse } from "swr";
import {
  ComercialRulesPaymentParams,
  ComercialRulesPaymentResponse,
} from "@letsbit/malcolmlb";
import { useAuthSWR } from "hooks/utils/useAuthSWR";
import { ApiContext } from "providers/ApiProvider";

export const SWR_GET_PAYMENTS_COMERCIAL_RULES =
  "get-payments-comercial-rules-key";

export const useGetPaymentsComercialRules = (
  params: ComercialRulesPaymentParams,
): SWRResponse<ComercialRulesPaymentResponse> => {
  const { memberInstance } = useContext(ApiContext);

  const swr = useAuthSWR(
    [SWR_GET_PAYMENTS_COMERCIAL_RULES, params],
    async () => {
      const { data } = await memberInstance.payments.getComercialRules(params);
      return data;
    },
  );
  return swr;
};
